import { memo, useEffect } from 'react'
import * as styles from './NewsletterSignUpForm.module.scss'

/**
 * The `NewsletterSignUpForm`
 * @returns {React.ReactElement} the element
 */
function NewsletterSignUpForm () {
  useEffect(() => {
    const script = document.createElement('script')

    script.src =
      'https://eomail6.com/form/557f1c4c-2cae-11f0-9939-25e130449147.js'

    script.async = true
    script.dataset.form = '557f1c4c-2cae-11f0-9939-25e130449147'

    document
      .getElementById('email-octopus-form-container')
      ?.appendChild(script)

    return () => {
      // clean up the script on unmount
      document
        .getElementById('email-octopus-form-container')
        ?.removeChild(script)
    }
  }, [])

  return (
    <div
      id="email-octopus-form-container"
      className={styles.container}
    />
  )
}

export default memo(NewsletterSignUpForm)
